import { adminHttpClient } from '../../commons/adminHttpClient'
import { WizardDto } from '../../adminSignUp/common/models'

const getPerksEligibleEmployeeWizard = (): Promise<WizardDto> => {
  return adminHttpClient.get('/EESignup/Perks/Wizard').then((response: any) => {
    return response.steps
  })
}

export default getPerksEligibleEmployeeWizard
